import 'react';
import {contentRoot} from '../config'
import { Field } from 'react-final-form';
import { Rating } from 'react-simple-star-rating'
const StartRatingInput = ({ name, label }) => {
    return (<Field name={name} type="number">
        {({ input, meta }) => (
            <div className="inputWithLabel">
                <label htmlFor={name} className="textinputLabel">{label} </label>
                <Rating onClick={(e) => input.onChange(e)}></Rating>
                {meta.error && meta.touched && <span className="errors">{meta.error}</span>}
            </div>
        )}
    </Field>);
};
export default StartRatingInput;

